import React from 'react' 
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useState } from 'react';
import styled from 'styled-components';
import { HashLink } from 'react-router-hash-link';


function Navbar(props) {
    const [active, setActive] = useState(false);
    const toggleMenu = ()=>{ 
        setActive(active === true ?  false : true);
     }
  return (
     <Container className={props.bg ? 'bg-pm nv' : 'nv'} >
         <div className="wrapper">
         <div className="navbar">
            <div className="navbar-item">
                <Link to='/'>
                    <div className="logo">
                        <div className="logo-text">K</div>
                    </div>
                </Link>
            </div> 
            <div className="navbar-item">
                <div className="close-btn"  onClick={()=>toggleMenu()}>
                <FaBars/>
                </div>
                <div className={`navbar-item  ${active ? ' active' :  ''} `}>
                <br />
                <div className="close-btn" onClick={()=>toggleMenu()}>
                        <FaTimes/>
                </div>
                <br />
                <ul>
                    <HashLink onClick={toggleMenu}   smooth to="/#about"><li>01. <span>About</span></li></HashLink>
                    <HashLink onClick={toggleMenu}  smooth to="/#work"><li>02. <span>Work</span></li></HashLink>
                    <HashLink onClick={toggleMenu}  smooth to="/#skills"><li>03. <span>Skills</span></li></HashLink>
                    <HashLink onClick={toggleMenu}  smooth to="/#projects"><li>04. <span>Projects</span></li></HashLink>
                    <HashLink onClick={toggleMenu}  smooth to="/#contacts"><li>05. <span>Contacts</span></li></HashLink>
                </ul>
                <div className="buttons">
                    <Link to='/resume' onClick={toggleMenu} ><button className='bg-main box-text'>Resume</button></Link>
                    <a href="https://www.linkedin.com/in/kiosso-camuegi-564b79211/" target="_blank" rel="noopener noreferrer">
                         <button className='ml-2'>My Linkedin</button>
                    </a>
                </div>
                </div>
            </div> 
            </div>
         </div>
     </Container>
  )
}

const Container = styled.div`

`;

export default Navbar
